// extracted by mini-css-extract-plugin
module.exports = {"button":"description_button__JmA-m"};